// extracted by mini-css-extract-plugin
export default {"form":"UsedInKind_form__5wAq4","formHeader":"UsedInKind_formHeader__e3duK","formBody":"UsedInKind_formBody__MWBKw","spinner":"UsedInKind_spinner__GO+Fl"};